module.exports = __webpack_public_path__ + "web/img/sign-70.48723d43.png";